export const selectCheckout = state => state.checkout.checkoutSession;
export const selectCheckoutId = state => state.checkout.checkoutSession?.id;

export const selectCheckoutReturnUrl = store => store.checkout.returnUrl;
export const selectSubscription = store => store.checkout.subscription;
export const selectExtensionDetails = store => store.checkout.extensionDetails;

export const selectCheckoutRedirectToTenant = store => store.checkout.checkoutSession?.redirect_to_tenant;